import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ContractLookup } from '@/components/v1/ContractLookup';
import { ContractResponse } from '@/components/v1/ContractResponse';
import type { ContractInfo } from '@/api/smart-contracts';

export default function Blockchain() {
  const [response, setResponse] = useState<ContractInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  function handleResponse(data: ContractInfo) {
    setResponse(data);
    setError(null);
  }

  function handleError(message: string) {
    setError(message || null);
    setResponse(null);
  }

  function handleClear() {
    setResponse(null);
    setError(null);
  }

  return (
    <div className="bg-gray-900 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-8"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Blockchain
          </h1>

          <div className="space-y-4">
            <label className="block text-sm font-medium text-gray-300">
              Contract address
            </label>
            <ContractLookup
              onResponse={handleResponse}
              onError={handleError}
            />
          </div>

          <ContractResponse
            response={response}
            error={error}
            onClear={handleClear}
          />
        </motion.div>
      </div>
    </div>
  );
}
